import httpRequest from '@/request'

const API = {
    CONSUMRISE: '/front/energygov/v1/supervisionCollectRecordsMonthComprehensive/rise',//综合能源消费量同比
    CONSUMTREND:  '/front/energygov/v1/supervisionCollectRecordsMonthComprehensive/energyTrend',//综合消费走势
    CONSUMPTIONRATIO: '/front/energygov/v1/supervisionCollectRecordsMonth/consumptionRatio',//能源消费结构占比
    TYPETREND: '/front/energygov/v1/supervisionCollectRecordsMonth/energyTypeTrend',//用能单位能源消费结构趋势
    ENTITYTREND: '/front/energygov/v1/supervisionCollectRecordsMonth/energyEntityTrend', //能源实物消耗量趋势查询
    PRODUCT: '/front/energygov/v1/supervisionCollectRecordsMonth/productOutput',//主要产品产量
    PRODUCTENERGY: '/front/energygov/v1/supervisionCollectRecordsMonth/productEnergy',//单位产品能耗
    COMPANYINFO: '/front/energygov/v1/supervisionCollectEnterpriseInfo/', //企业详情查询
    OUTPUT:'/front/energygov/v1/supervisionCollectRecordsMonthComprehensive/output',//万元工业总产值能耗概况查询 
    OUTPUTTRENDS:'/front/energygov/v1/supervisionCollectRecordsMonthComprehensive/outputTrends',//万元工业总产值能耗趋势查询接口 
    INDUSTRIALRISE:'/front/energygov/v1/supervisionCollectRecordsMonthComprehensive/industrialRise',//万元工业增加值能耗概况查询
    ADDENERGYTREND:'/front/energygov/v1/supervisionCollectRecordsMonthComprehensive/addEnergyTrend',//万元工业增加值能耗趋势查询
    EQUIPMENTENERGY:'/front/energygov/v1/supervisionCollectRecordsMonth/equipmentEnergy' ,//设备能效数据查询
    CARBODEMISSION:'/front/energygov/v1/supervisionCollectRecordsMonth/carbonEmissionSurvey' ,//碳排放概况数据查询
    CARBODEMISSIONTREND:'/front/energygov/v1/supervisionCollectRecordsMonth/carbonEmissionTrend',//碳排放趋势数据查询
    UTILIZATION:'/front/energygov/v1/supervisionEnergyUtilization/list/', //获取能源利用状况报表
    ENERYUTILIZATION:'/front/energygov/v1/supervisionEnergyUtilization/', //能源利用状况报告确认或退回
    EQUIPMENTINFO:'/front/energygov/v1/supervisionEquipmentInfo/list/', //获取重点能耗设备信息列表

}

export function getConsumptionRiseRequest(params: any) {
    return httpRequest({
      url: API.CONSUMRISE,
      method: 'get',
      params
    })
}
export function getConsumTrendRequest(params: any) {
    return httpRequest({
      url: API.CONSUMTREND,
      method: 'get',
      params
    })
}
export function getConsumptionRatioRequest(params: any) {
    return httpRequest({
      url: API.CONSUMPTIONRATIO,
      method: 'get',
      params
    })
}
export function getTypeTrendRequest(params: any) {
    return httpRequest({
      url: API.TYPETREND,
      method: 'get',
      params
    })
}
export function getEntityTrendRequest(params: any) {
    return httpRequest({
      url: API.ENTITYTREND,
      method: 'get',
      params
    })
}
export function getProductRequest(params: any) {
    return httpRequest({
      url: API.PRODUCT,
      method: 'get',
      params
    })
}
export function getProductEnergyRequest(params: any) {
    return httpRequest({
      url: API.PRODUCTENERGY,
      method: 'get',
      params
    })
}
export function getCompanyInfoRequest(params: any) {
    return httpRequest({
      url: API.COMPANYINFO+params.id,
      method: 'get',
      params
    })
}
export function output(params: any) {
    return httpRequest({
      url: API.OUTPUT,
      method: 'get',
      params
    })
}
export function outputTrends(params: any) {
    return httpRequest({
      url: API.OUTPUTTRENDS,
      method: 'get',
      params
    })
}
export function industrialRise(params: any) {
    return httpRequest({
        url: API.INDUSTRIALRISE,
        method: 'get',
        params
    })
}
  
export function addEnergyTrend(params: any) {
    return httpRequest({
        url: API.ADDENERGYTREND,
        method: 'get',
        params
    })
}
export function equipmentEnergy(params:any){
    return httpRequest({
        url:API.EQUIPMENTENERGY,
        method:'get',
        params
    })
}
export function getcarbonEmission(params:any){
    return httpRequest({
        url:API.CARBODEMISSION,
        method:'get',
        params
    })
}
export function getcarbonEmissionTrend(params:any){
    return httpRequest({
        url:API.CARBODEMISSIONTREND,
        method:'get',
        params
    })
}
//获取能源利用状况报告列表
export function getUtilizationListRequest(params: any) {
    return httpRequest({
      url: API.UTILIZATION+params.id,
      method: 'get',
      params
    })
}
//能源利用状况报告确认或退回
export function getEnergyUtilizationRequest(params:any){
    return httpRequest({
        url:API.ENERYUTILIZATION+params.id,
        method:'put',
        data:params
    })
}
//获取重点能耗设备信息列表
export function getEquipmentInfoRequest(params:any){
    return httpRequest({
        url:API.EQUIPMENTINFO+params.id,
        method:'get',
        params
    })
}